import React from "react";
//Icons
import {
    Card, CardBody, CardGroup
} from 'reactstrap';
import {appHelpers} from "../../_helpers";

import IconPayment from 'react-icons/lib/md/payment';
import IconAirline from 'react-icons/lib/md/airplanemode-active';
import IconMdDate from 'react-icons/lib/md/date-range';

class MatchedRecordPanel extends React.Component {
    render() {
        let { activeReconciliation } = this.props;
        return (
            <CardGroup className="sales-card mb-4">
                <Card style={{'flex': '1.5 0 0'}}>
                    <CardBody  className="justify-content-between fit">
                        <h5 className="text-uppercase title font-weight-bold small">
                            <IconAirline size="20" color="#43a8df"/>&nbsp;
                            Issuer
                        </h5>
                        <h4 className="font-weight-normal mb-0">
                            {activeReconciliation.Issuer}
                        </h4>
                    </CardBody>
                </Card>
                <Card>
                    <CardBody className={'fit'}>
                        <h5 className="text-uppercase title font-weight-bold small">
                            <IconMdDate size="20" color="#b52c2c"/>&nbsp;
                            Issue Date
                        </h5>
                        <h4 className="font-weight-normal mb-0">
                            {appHelpers.formatDate(activeReconciliation.IssueDate)}
                        </h4>
                    </CardBody>
                </Card>
                <Card style={{'flex': '1.5 0 0'}}>
                    <CardBody className={'fit'}>
                        <h5 className="text-uppercase title font-weight-bold small">
                            <IconPayment size="20" color="#00c853"/>
                            &nbsp;Payment Amount
                        </h5>
                        <h4 className="font-weight-normal mb-0">
                             {`${String.fromCharCode(appHelpers.getCurrencyUnicode(activeReconciliation.Currency))}${appHelpers.numberWithCommas(activeReconciliation.BilledAmount)}`}
                        </h4>
                    </CardBody>
                </Card>
            </CardGroup>
        )
    }
}
export default MatchedRecordPanel;



// WEBPACK FOOTER //
// ./src/views/matchPayment/matched-panel.js